import { Firestore } from "firebase-admin/firestore";

/**
 * ⏳ CORTE TEMPORAL DEL GO-LIVE — UN DORMIDO NO SE REACTIVA SOLO.
 *
 * ══════════════════════════════════════════════════════════════════════════════
 * ESTE MÓDULO SE BORRA ENTERO EN EL PR QUE CIERRE EL #610. No es arquitectura,
 * es una tirita con fecha. Todo lo que necesita para desaparecer sin dejar
 * rastro vive aquí dentro: un fichero, DOS sitios de uso y unos textos.
 *
 * LOS DOS SITIOS, desde el 2026-07-26:
 *
 *   1. `QuoteSubscription` (`Payments/PaymentsFunc.ts`) — LA DEFENSA DE VERDAD.
 *      Es la que impide que un dormido compre y se recoloque en su línea vieja.
 *      Se queda aunque la interfaz ya no le enseñe ningún botón: la callable es
 *      pública y no se defiende escondiendo el botón que la llama.
 *
 *   2. `SubscriptionsPanel.vue` (front) — LA CARA AMABLE. El propio dormido ya
 *      no ve tarjetas de compra ni recibe un `alert()` del navegador después de
 *      pulsar: ve UNA tarjeta con `DORMANT_SELF_MESSAGE` y ya está. De ahí que
 *      el front importe de aquí los dos símbolos que necesita
 *      (`isDormantUnplaced` y el texto) en vez de copiarse la cadena.
 *
 * EL REGISTRO YA NO ESTÁ EN ESTA LISTA. Hasta el 2026-07-26 `doRegisterUser`
 * traía sus propios textos explicativos; Hector decidió que por `/register` y
 * `/tools` se conteste lo de siempre —«Nombre de usuario no disponible»— sin
 * mencionar reactivaciones. La conversación con soporte la abre el dormido desde
 * SU panel, que es donde sabemos con certeza quién está al otro lado.
 * ══════════════════════════════════════════════════════════════════════════════
 *
 * QUÉ PROBLEMA TAPA. El barrido del reinicio (#558) VACÍA el `enroller` de los
 * ~41.6k usuarios dormidos y guarda su cadena vieja en
 * `users/{u}["~legacy"].uplines` — el «puente de reactivación» (ver
 * `Subscriptions/Activations/EnrollerChain.ts`). Cuando un dormido reactiva, ese
 * puente le reconstruye su línea ascendente DE ANTES del reinicio, que casi
 * siempre cuelga de alguien que ya no está en la red nueva. No falla nada: se
 * dispersan puntos y se pagan comisiones por la pierna equivocada, en silencio, y
 * deshacer una colocación es la operación más cara que existe en una red.
 *
 * La solución de verdad es el #610: aparcar la cotización hasta que alguien
 * AUTORICE el patrocinador nuevo. Hasta que exista, esto: el dormido no puede
 * reactivarse por su cuenta, tiene que pasar por soporte.
 *
 * ──────────────────────────────────────────────────────────────────────────────
 * EL DISCRIMINANTE: `enroller` VACÍO. Nada más.
 *
 * No hace falta inventar ninguna marca porque el propio motor de cadenas ya usa
 * ésta. `EnrollerChain.ancestorsOf` (líneas 218-259) resuelve en este orden:
 * alias → `enroller` vivo → apex → `~legacy.uplines`. Es decir, **el campo vivo
 * SIEMPRE gana, y `~legacy` sólo se consulta cuando `users.enroller` está
 * vacío**. Y en cuanto alguien queda colocado, `placeMember` le escribe su
 * `enroller` nuevo (`PlaceMember.ts:978`) y el puente no se vuelve a leer para
 * esa persona nunca más.
 *
 * Luego «`enroller` vacío» NO es una heurística sobre el caso peligroso: ES el
 * caso peligroso, definido con el mismo campo que lo dispara.
 *
 * POR QUÉ NO SE MIRA `resetSweptAt`, que sería lo cómodo. Dos razones:
 *
 *   1. NO DISCRIMINA. La lleva TODO EL MUNDO, incluidos los ~40 activos que el
 *      paso 15 colocó después («Nobody is skipped for being special»,
 *      network-reset-sweep-users.js:41). Usarla a secas bloquearía la red entera.
 *
 *   2. AÑADIRLA COMO SEGUNDA CONDICIÓN LE PONE AL CORTE UNA CADUCIDAD INVISIBLE.
 *      Existe `scripts/network-reset-drop-reset-swept-at.js`, que borra la marca
 *      de los 41.6k documentos cuando pasa la ventana de observación. El día que
 *      alguien lo ejecute, un corte que dependiera de ella dejaría de bloquear a
 *      NADIE — sin un error, sin un log, sin un test en rojo. Un corte que se
 *      apaga solo y en silencio es peor que no tener corte, porque nadie vuelve a
 *      mirarlo. El propio `UsersInterfaces.ts:120` avisa: «no production code
 *      path reads it, and nothing should start to».
 *
 * ──────────────────────────────────────────────────────────────────────────────
 * ¿A QUIÉN MÁS ATRAPA? La pregunta importante, porque romper el alta de clientes
 * nuevos el día del go-live sería infinitamente peor que el problema que esto
 * resuelve. Los candidatos, uno a uno:
 *
 *   - UN REGISTRO RECIÉN HECHO que aún no ha comprado → NO le afecta.
 *     `doRegisterUser` EXIGE patrocinador, verifica que su documento existe
 *     (`UsersFunc.ts:267-320`) y escribe `enroller: enrollerPK` en el `t.create`
 *     (`UsersFunc.ts:400`). Un alta nueva no puede tener el campo vacío: si el
 *     patrocinador falta o no existe, no hay usuario que valga. Es la condición
 *     que hace seguro el discriminante, y hay un test que la fija.
 *
 *   - UN ALTA A MEDIAS (Auth creado, Firestore no) → NO le afecta. El `catch`
 *     del registro borra la cuenta de Auth (`UsersFunc.ts:466-473`); no queda un
 *     `users/{u}` sin enroller, queda que no queda nada.
 *
 *   - `rootuser` y `gtr.academy` → SÍ tienen el campo vacío (`rootuser` nace con
 *     `enroller: null` en `databaseSetup.ts:390`; `gtr.academy` queda a `""` para
 *     siempre porque el barrido lo vacía y `resolveDraft` hace `members.delete`,
 *     así que nunca se re-coloca). SÍ los atraparía, y no es un problema: son
 *     cuentas técnicas, no compran suscripciones desde la interfaz, y que no
 *     puedan hacerlo es lo correcto. No se les hace excepción a propósito — una
 *     allowlist es más código que retirar luego, y taparía justo el caso del que
 *     querríamos enterarnos.
 *
 *   - `gtr.master`, la cuenta de empresa → NO le afecta al descongelar. Se queda
 *     con `enroller: ""` sólo entre el paso 10 (barrido) y el paso 15 (seed), que
 *     le devuelve `enroller: rootuser` desde el ancla; esa ventana entera está
 *     DENTRO del freeze, con el sistema parado y nadie cotizando. Si un día el
 *     ancla faltara del JSON, se quedaría vacío — pero entonces el problema es
 *     mucho mayor que no poder comprar, y hay invariantes del gate que lo cazan
 *     antes que esto.
 *
 *   - UN DORMIDO YA REACTIVADO por soporte → NO le afecta, y ésta es la salida.
 *     En cuanto se le coloca, tiene `enroller`, y a partir de ahí cotiza como
 *     cualquiera.
 *
 * ──────────────────────────────────────────────────────────────────────────────
 * LO QUE ESTE CORTE NO TOCA, Y NO DEBE TOCAR: LAS ACTIVACIONES DE ADMINISTRADOR.
 *
 * Soporte tiene que poder activar a mano al mismo usuario que esto bloquea, con
 * el patrocinador correcto. Esa vía es `Admin-ActivateSubscriptionWithoutVolume`
 * (`Admin/AdminFuncs.ts:418`, desde `sys-config → users-tools`), que NO crea
 * cotización y por tanto NO pasa por aquí. Si un cambio futuro hiciera que la
 * activación manual pasara por esta compuerta, la salida de emergencia quedaría
 * cerrada y el corte sería inaceptable: revísalo antes de mover nada.
 */

/**
 * Los únicos campos de `users/{u}` que mira la compuerta. Deliberadamente
 * mínimo: cuanto menos lea, menos hay que entender el día que se retire.
 */
export interface DormantGateDoc {
  enroller?: string | null;
}

/**
 * La dirección que la aplicación ya usa en todas partes (`_constants/mail.ts`,
 * las conversaciones de Telegram, `VirtualClassroom.vue`…). No se parametriza:
 * un corte de tres días no necesita configuración.
 */
export const SUPPORT_EMAIL = "soporte@gtr.academy";

/**
 * Lo lee EL DORMIDO en SU panel de suscripciones, donde desde el 2026-07-26 es
 * el contenido de la única tarjeta que ve (`SubscriptionsPanel.vue`). Sin
 * códigos de error, sin disculpas y sin jerga («cotización», «enroller»,
 * «suscripción no vigente»): sólo qué pasa y qué hacer.
 *
 * «Dinos quién te recomendó» está a propósito. Es justo el dato que soporte
 * necesita para desbloquearlo; sin pedirlo aquí, soporte tiene que contestar
 * preguntándolo y se pierde un día en el ida y vuelta.
 *
 * Sigue siendo además la respuesta de `QuoteSubscription` cuando el propio
 * dormido llega a la callable por otro camino (una pestaña vieja, la agenda de
 * la academia): el texto es el mismo lo pinte quien lo pinte.
 */
export const DORMANT_SELF_MESSAGE =
  `Tu cuenta no se puede activar desde aquí. Escríbenos a ${SUPPORT_EMAIL} ` +
  `y dinos quién te recomendó, y te la reactivamos.`;

/**
 * Lo lee UN TERCERO desde `/tools`, cuando intenta cobrarle a alguien que resulta
 * ser un dormido.
 *
 * SECO A PROPÓSITO (decisión de Hector, 2026-07-26). La versión anterior le
 * contaba que la cuenta estaba inactiva, que venía de otra línea y que escribiera
 * a soporte. Eso convertía `/tools` en un buscador de dormidos: cualquiera con
 * sesión podía teclear nombres y averiguar quién está fuera de la red y quién
 * está colocado, sin ser esa persona ni tener nada que ver con ella. La
 * conversación con soporte la abre EL DUEÑO de la cuenta desde su propio panel,
 * donde sí sabemos quién está al otro lado.
 *
 * No nombra al usuario ni dice por qué. «No está disponible» es cierto y es todo
 * lo que a quien pregunta le corresponde saber.
 */
export const DORMANT_SPONSOR_MESSAGE = "Ese usuario no está disponible.";

/**
 * `true` cuando el documento describe a alguien SIN colocar en la red nueva —
 * el caso, y el único, en que la activación tiraría del puente `~legacy`.
 *
 * Un documento que NO EXISTE devuelve `false` a propósito: «no hay usuario» no es
 * «hay un dormido», y el error que corresponde a eso lo da el flujo de cotización
 * por su cuenta. Esta compuerta responde una sola pregunta y no opina de las demás.
 */
export function isDormantUnplaced(data: DormantGateDoc | undefined): boolean {
  if (data == undefined) {
    return false;
  }
  return (data.enroller ?? "").trim() === "";
}

/**
 * El mensaje que hay que devolverle a quien pide la cotización, o `undefined` si
 * puede seguir adelante.
 *
 * `db` es un parámetro y no un `getProdDb()` por dentro para que este módulo sea
 * una HOJA — igual que `EnrollerChain.ts` —: así la suite del emulador lo prueba
 * pasando su propia base, sin arrastrar `initFirebase` (que en tiempo de import
 * decide si habla con GCP de verdad).
 *
 * @param usernamePK    a quién se le cotiza, en minúsculas.
 * @param requesterPK   quién lo pide (`context.auth.token.name`), en minúsculas.
 *                      Cuando no coincide con `usernamePK` el mensaje es el del
 *                      patrocinador. `undefined` (no hay identidad) se trata como
 *                      «es él mismo»: es el texto más conservador de los dos, no
 *                      nombra a nadie y no confirma a un tercero que esa cuenta
 *                      exista.
 */
export async function dormantQuoteBlockMessage(
  db: Firestore,
  usernamePK: string,
  requesterPK: string | undefined
): Promise<string | undefined> {
  const snap = await db.collection("users").doc(usernamePK).get();
  const data = snap.data() as DormantGateDoc | undefined;
  if (!isDormantUnplaced(data)) {
    return undefined;
  }
  const requester = (requesterPK ?? "").toLowerCase().trim();
  if (requester === "" || requester === usernamePK) {
    return DORMANT_SELF_MESSAGE;
  }
  return DORMANT_SPONSOR_MESSAGE;
}
